<template>
  <v-select
    v-model="selectedProfileGuid"
    :items="tierItems"
    item-text="label"
    item-value="profile_guid"
    :loading="loading"
    :disabled="disabled"
    label="Cloud Pro API plan"
    hint="Pro, Pro Plus, or Pro Ultra. Use a custom profile for one-off grants."
    persistent-hint
    outlined
    hide-details="auto"
  />
</template>

<script>
  function formatTierLabel(value) {
    if (value >= 1_000_000) {
      return `${value / 1_000_000}M`
    }
    if (value >= 1_000) {
      return `${value / 1_000}K`
    }
    return String(value)
  }

  export default {
    name: 'CloudProTierSelector',

    props: {
      value: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        loading: false,
        selectedProfileGuid: '',
      }
    },

    computed: {
      tierProfiles() {
        return this.$entitlementProfiles.profiles
          .filter((profile) => (
            profile.isCloudProBaseProfile()
            || profile.isCatalogProfile()
          ))
          .sort((left, right) => {
            var leftTier = this.tierValue(left)
            var rightTier = this.tierValue(right)
            return leftTier - rightTier
          })
      },

      tierItems() {
        return this.tierProfiles.map((profile) => {
          var tier = this.tierValue(profile)
          return {
            profile_guid: profile.profile_guid,
            label: `${profile.profile_name} (${formatTierLabel(tier)} requests/device/month)`,
          }
        })
      },
    },

    watch: {
      value(value) {
        this.selectedProfileGuid = value
      },

      selectedProfileGuid() {
        this.$emit('input', this.selectedProfileGuid || '')
      },
    },

    async mounted() {
      this.loading = true
      await this.$entitlementProfiles.allEntitlementProfiles()
      this.selectedProfileGuid = this.value
      this.loading = false
    },

    methods: {
      tierValue(profile) {
        var properties = profile.properties || {}
        return properties['services.cloud.api_monthly_requests'] || 0
      },
    },
  }
</script>
